import { ToPersianNumber } from "../index";
function NationalCodeSeparator(num) {
  let result = Array.from(String(num), Number);  
  let pruned = [];
  for (let index = 0; index < result.length; index++) {
    pruned.push(ToPersianNumber(result[index].toString()));
    if (index === 2) {
      pruned.push(" - ");
    }
    if (index === 8) {
      pruned.push(" - ");
    }
  }
  return pruned.join("");
}
export default NationalCodeSeparator;
